var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765 4673 c-47 -24 -86 -64 -106 -108 -18 -38 -19 -111 -19 -1890 0 -1283 3 -1862 11 -1889 14 -50 82 -118 135 -134 32 -9 456 -12 1890 -12 1778 0 1851 1 1889 19 77 36 125 111 125 196 0 83 -39 148 -115 188 l-40 22 -1732 3 -1733 2 -2 1733 -3 1732 -22 40 c-27 50 -58 80 -105 100 -48 19 -134 19 -173 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4180 4674 c-46 -20 -77 -50 -103 -99 l-22 -40 -3 -1410 c-2 -1045 0 -1424 8 -1464 16 -74 83 -143 156 -160 98 -24 193 20 238 110 l26 53 0 1428 c0 1565 4 1466 -58 1531 -61 64 -162 86 -242 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 4028 c-25 -14 -58 -44 -75 -67 l-30 -43 -3 -1121 c-2 -778 0 -1133 8 -1159 35 -120 187 -180 300 -118 24 14 58 45 75 68 l30 44 0 1142 0 1143 -27 39 c-44 62 -90 88 -167 92 -55 3 -74 -1 -111 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3362 3620 c-57 -13 -108 -55 -136 -111 l-26 -53 0 -896 0 -896 26 -53 c67 -134 244 -158 342 -46 23 27 44 63 51 90 8 30 11 304 11 905 0 601 -3 875 -11 905 -17 66 -78 131 -142 150 -55 16 -66 17 -115 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648 2978 c-21 -5 -58 -28 -82 -50 -77 -67 -76 -61 -76 -685 0 -384 3 -558 12 -591 16 -66 87 -135 154 -151 98 -24 193 20 238 110 l26 53 0 577 0 577 -28 53 c-46 89 -149 134 -244 107z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.ced7e35a49b51443b8f38a6d584ffc28.svg";
export { ForwardRef as ReactComponent };